<template>
  <div class="ord_item_con" v-if="!isOpenBooking">
    <div class="item_head_con">
      <RcclCheckBox v-if="isShowSelector && booking.bookingBusinessStatus.shouldPayBalanceOnline == true" :defaultChecked="isBookingSelected" v-on:onChanged="onSelectChanged" />
      <span>
        <img class="c_userCenterImg" @click="onConnectRoomClicked()"
          src="https://resource.rcclchina.com.cn/cruiseDetail/pc/custom_info.png"
          style="width: 95px;position: relative;top: -2px;" v-if="booking.connectId && booking.connectId.length > 0">

        <img class="qiaohu_tag" @click="onQiaohuRoomClicked(booking)"
          v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
          src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png" style="width: 95px;position: relative;top: -2px;">
        <img class="starry_sky_tag" @click="onStarrySkyRoomClicked(booking)"
             v-else-if="booking.groupType == 'STARRYSKY'"
             src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png" style="width: 95px;position: relative;top: -2px;">
        <img class="pcp_gift_tag" @click="onCustomThemeRoomClicked(booking.personalizedStateroomInfo)"
             v-else-if="booking.groupType == 'PCPGIFT'"
             :src="booking.personalizedStateroomInfo?.roomIconImage" style="position: relative;top: -2px;">
        <img class="custom_theme_tag" @click="onCustomThemeRoomClicked(booking.personalizedStateroomInfo)"
             v-else-if="booking.groupType == 'CUSTOM'"
             :src="booking.personalizedStateroomInfo?.roomIconImage" style="position: relative;top: -2px;">
      </span>

      <span>船票预订号：</span>
      <span class="head_text ft-400">{{ booking.bookingId }}</span>
      <span class="item_head_split">|</span>
      <span>房型：</span>
      <span class="head_text ft-400">{{ booking.stateroomCategoryName }}</span>
      <span class="item_head_split">|</span>
      <span>预订日期：</span>
      <span class="head_text ft-400">{{ bookingCreateDate }}</span>
    </div>

    <div class="item_con" :class="{'isCancelled': booking.bookingBusinessStatus.paymentStatusCode == 'CANCELLED'}">
      <div class="item_com line_w line_con">
        <div class="center_con">
          <div class="line_title ft-400">{{ booking.cruiseRoute }}</div>
          <div class="ship_departure fz-12">
            {{ booking.shipName }} {{ booking.routeNights }}
          </div>
        </div>
      </div>
      <div class="item_com passengers_w">
        <div class="center_con tac">
          <div class="user_con ft-400">
            <div v-for="(guestName, i) in guestNames" :key="('guestName_' + i)">
              {{ guestName }}
            </div>
            <template v-if="booking.bookingBusinessStatus.paymentStatusCode != 'CANCELLED' && booking.allowFillGuest">
              <router-link class="fill-guest-btn" :to="orderDetailLink" :id="`fill-guest-btn-${booking.bookingId}`">
                <img :src="`${imgUrl}/icons/icon-plus-blue.png`" />
                <span>补全乘客</span>
              </router-link>
              <b-tooltip :target="`fill-guest-btn-${booking.bookingId}`" triggers="hover" placement="top"
                :boundary="'.user_con'" :container="`fill-guest-btn-${booking.bookingId}`" :fallback-placement="['top']">
                建议开航<span class="fc-red">45</span>天前补全全部乘客信息，开航前<span class="fc-red">7</span>天及以内不可再进行修改
              </b-tooltip>
            </template>
          </div>
        </div>
      </div>
      <div class="item_com ship_w">
        <div class="center_con ft-400" style="text-align: center;">
          <div>{{ getSailDateText(booking.sailDateBegin) }}</div>
          <img src="https://resource.rcclchina.com.cn/personalCenter/back-icon.png">
          <div>{{ getSailDateText(booking.sailDateEnd) }}</div>
        </div>
      </div>
      <div class="item_com money_w">
        <div class="center_con ">
          <div class="money_title ft-600">{{ booking.currencyIcon }}{{ booking.amount }}</div>
          <div class="fz-12" v-if="(booking.total - booking.payAmount > 0 && booking.payAmount > 0)">
            已付订金：{{ booking.currencyIcon }}{{ booking.payAmount }}
          </div>
        </div>
      </div>
      <div class="item_com operation_w">
        <div class="center_con op_con ft-400">
          <div class="op_text_inner is-tip">
            <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.bookingBusinessStatus.paymentStatusCode != 'CANCELLED'">
              <div class="op_text">
                {{getTikTokCouponStatus(booking.tikTokCouponStatus)}}<br/><span v-if="booking.tikTokRejectReason">({{booking.tikTokRejectReason}})</span>
              </div>
            </template>
            <template v-else>
              <div class="payBtn" v-if='booking.bookingBusinessStatus.shouldPayBalanceOnline == true && !isShowSelector'>
                <div class="op_btn" v-if="booking.bookingBusinessStatus.paymentStatus == 1">立即支付
                </div>
                <div class="op_btn" v-else-if="booking.bookingBusinessStatus.paymentStatus == 2">支付尾款
                </div>
                <router-link class="hold_link" :to="payLink"></router-link>
              </div>
              
              <div class="op_text" :class="paymentStatusTagClass">
                {{booking.bookingBusinessStatus.paymentStatusText}}
              </div>

            </template>
            <div v-if="booking.bookingBusinessStatus.paymentStatusCode != 'CANCELLED'" class="op_text blue"> <router-link :to="orderDetailLink">订单详情</router-link>
            </div>
            <div class="op_text blue" v-else> <router-link :to="cruiseDetailLink">重新下单</router-link>
            </div>
            <div v-if="booking.showInvoiceLink" class="op_text blue"> <div class="invoice-btn" @click="showInvoiceList(booking)">{{booking.invoiceStatusStr}}</div>
            <div v-if="upgradeCabinItem && upgradeCabinItem.displayBiddingEntrance" class="bidding-status" @click="showWxQrCode">
              <div v-if="upgradeCabinItem.canBidding">
                <span v-if="upgradeCabinItem.biddingStatus==20">未竞价成功</span>
                <span v-else>竞价升房</span>
              </div>
              <div v-if="!upgradeCabinItem.canBidding">
                <span :style="upgradeCabinItem.biddingStatus==10||upgradeCabinItem.biddingStatus==40||upgradeCabinItem.biddingStatus==50?'color: #5cb139':''" >{{getBiddingStatusText(upgradeCabinItem.biddingStatus)}}</span>
              </div>
            </div>
          </div>
          <template v-if="!getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.bookingBusinessStatus.shouldPayBalanceOnline == true && !isShowSelector">
            <el-popover placement="right" title="" width="160" trigger="hover">
              <div v-if="booking.bookingBusinessStatus.paymentStatus == 1">请尽快支付未付款金额，否则在开航前7天会自动取消订单。</div>
              <div v-else-if="booking.bookingBusinessStatus.paymentStatus == 2">开航前45天(不含）订单将被取消，请尽快支付尾款。</div>
              <div class="op_tip_img" slot="reference">
                <img :src="`${imgUrl}/tui2/info/tips.png`">
              </div>
            </el-popover>
          </template>
        </div>
      </div>
    </div>
    <div v-if="booking.bookingBusinessStatus.paymentStatusCode != 'CANCELLED' && booking.unFilledGuest" class="cabinItem-un-filled-red">
        <img class="icon" :src="`${imgUrl}/icons/icon-warning-red.png`" />
        <div class="text">您有出行乘客未添加，请于开航45天前联系在线客服或致电400-8850-277补全。</div>
      </div>
      <div v-if="!booking.hasSubmittedSurvey" class="questionnaire" @click="toSurvey">
        <span class="scoreIcon"><img
            src="https://resource.rcclchina.com.cn/wechatMiniProgram/questionnaire/icons/pc_routeQNR.png" alt=""></span>
        <a>请对您的使用感受进行评分 >></a>
      </div>
  </div>
  </div>
  <div class="ord_item_con" v-else>
    <div class="item_head_con">
      <RcclCheckBox v-if="isShowSelector && canPay" :defaultChecked="isOpenBookingSelected"
        v-on:onChanged="onSelectChanged" />
      <span v-if="!isOpenBookingSendCoupon">
        <span>船票预订号：</span>
        <span class="head_text ft-400">{{ booking.bookingId ? booking.bookingId : "48小时内生成" }}</span>
      </span>
      <span v-else>抵用券</span>
      <span class="item_head_split">|</span>
      <span v-if="!isOpenBookingSendCoupon">
        <span>房型：</span>
        <span class="head_text ft-400">待定</span>
        <span class="item_head_split">|</span>
      </span>
      <span v-if="!isOpenBookingSendCoupon">预订日期：</span>
      <span v-else>下单日期：</span>
      <span class="head_text ft-400">{{ bookingCreateDate }}</span>
    </div>

    <div class="item_con">
      <div class="item_com line_w line_con">
        <div class="center_con">
          <div class="line_title ft-400">{{ booking.openBookingTitle }}</div>
          <div class="ship_departure fz-12">{{ booking.openBookingSubTitle }}
          </div>
        </div>
      </div>
      <div class="item_com passengers_w">
        <div class="center_con">
          <div class="user_con ft-400">
            <div v-for="(guestName, i) in guestNames" :key="('guestName_' + i)">
              {{ guestName }}
            </div>
          </div>
        </div>
      </div>

      <div class="item_com ship_w">
        <div class="center_con ft-400" style="text-align: center;" v-if="!isOpenBookingSendCoupon">日期待定</div>
      </div>
      <div class="item_com money_w">
        <div class="center_con ">
          <div class="money_title ft-600">￥{{ booking.amount }}</div>
        </div>
      </div>
      <div class="item_com operation_w">
        <div class="center_con op_con ft-400">
          <div class="op_text_inner is-tip">
            <div class="payBtn" v-if='status == "unpaid" && !isExpired && !isShowSelector'>
              <div class="op_btn">立即支付
              </div>
              <router-link class="hold_link" :to="payLink"></router-link>
            </div>
            <div class="payBtn"
              v-else-if='status == "unpaidFull" && (balanceDue + booking.payAmount == booking.total) && !isShowSelector'>
              <div class="op_btn">支付尾款
              </div>
              <router-link class="hold_link" :to="payLink"></router-link>
            </div>

            <div class="op_text" v-if="status == 'cancel'">已取消</div>
            <div class="op_text red" v-else-if="status == 'unpaid'">未付款</div>
            <div class="op_text red" v-else-if="status == 'unpaidFull'">未付全款</div>
            <div class="op_text" v-else-if='status == "paid" || status == "hasComment" || status == "noComment"'>已付款</div>
            <div class="op_text" v-else-if='status == "confirmed"'>已使用</div>
            <div v-if="status !== 'cancel'" class="op_text blue">
              <router-link :to="orderDetailLink">订单详情</router-link>
            </div>
            <div v-if="isOpenBookingSendGift" class="op_text blue">
              <a :href="giftLink">查看礼品</a>
            </div>
            <div class="op_text blue" v-if='status == "cancel"'> <router-link :to="cruiseDetailLink">重新下单</router-link>
            </div>
            <div v-if="upgradeCabinItem && upgradeCabinItem.displayBiddingEntrance" class="bidding-status" @click="showWxQrCode">
              <div v-if="upgradeCabinItem.canBidding">
                <span v-if="upgradeCabinItem.biddingStatus==20">未竞价成功</span>
                <span v-else>竞价升房</span>
              </div>
              <div v-if="!upgradeCabinItem.canBidding">
                <span :style="upgradeCabinItem.biddingStatus==10||upgradeCabinItem.biddingStatus==40||upgradeCabinItem.biddingStatus==50?'color: #5cb139':''" >{{getBiddingStatusText(upgradeCabinItem.biddingStatus)}}</span>
              </div>
            </div>
          </div>
          <el-popover placement="right" title="" width="160" trigger="hover">
            <div>该订单尚未支付，将于48小时后取消，请您及时付款。</div>
            <div v-if='status == "unpaid" && !isExpired && !isShowSelector' class="op_tip_img" slot="reference">
              <img :src="`${imgUrl}/tui2/info/tips.png`">
            </div>
          </el-popover>
          <el-popover placement="right" title="" width="160" trigger="hover">
            <div>开航前45天(不含）订单将被取消，请尽快支付尾款。</div>
            <div v-if='status == "unpaidFull" && (balanceDue + booking.payAmount == booking.total) && !isShowSelector'
              class="op_tip_img" slot="reference">
              <img :src="`${imgUrl}/tui2/info/tips.png`">
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox.vue')
export default {
  name: "BookingListItem",
  components: {
    RcclCheckBox
  },
  props: {
    booking: {
      type: Object
    },
    isShowSelector: {
      type: Boolean
    },
    selectedBooking: {
      type: Array
    },
    selectedOpenBooking: {
      type: Array
    },
    onBookingSelected: {
      type: Function
    },
    onOpenBookingSelected: {
      type: Function
    },
    onConnectRoomClicked: {
      type: Function
    },
    onQiaohuRoomClicked: {
      type: Function
    },
    onStarrySkyRoomClicked: {
      type: Function
    },
    onCustomThemeRoomClicked: {
      type: Function
    },
    orderItem: {
      type: Object,
      value: {}
    },
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL
    }
  },
  methods: {
    onSelectChanged() {
      if (this.isOpenBooking) {
        this.onOpenBookingSelected(this.booking)
      } else {
        this.onBookingSelected(this.booking)
      }
    },
    getSailDateText(sailDate) {
      if (!sailDate) return ""
      return sailDate.split(" (")[0]
    },
    getTikTokCouponStatus(status) {
      if (status === 1) {
        return "待审核"
      } else if (status === 3) {
        return "已拒绝"
      } else {
        return '';
      }
    },
    toSurvey() {
      this.$router.push({
        path: `/Rccl.CustomPage/questionnaire/SurveyQuestion`,
        query: {
          // 需要加密的bookingRecordId
          bookingRdId: this.orderItem.encBookingRecordId,
          pageFrom: 'order',
          type: 'HOME'
        }
      })

    },
    showInvoiceList(booking) {
      let status = booking.invoiceStatus
      if (status === 2 || status === 5) return
      if (status === 1) {
        this.$emit('showInvoiceList', booking)
      } else if (status === 3 || status === 4 || status === 6) {
        this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
          query: {
            invoiceApplyId: booking.invoiceApplyId,
          }
        })
      }
    },
    showWxQrCode(){
      this.$emit('showWxQrCode')
    },
    getBiddingStatusText(biddingStatus) {
      switch (biddingStatus) {
        case 0:
          return '竞价升房中';
        case 10:
          return '竞价成功';
        case 20:
          return '未竞价成功';
        case 30:
          return '竞价升房';
        case 40:
          return '竞价成功未付款';
        case 50:
          return '竞价成功已付款';
        default:
          return '';
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    isOpenBooking() {
      return bookingStatusHelper.isOpenBooking(this.booking)
    },
    isOpenBookingSendCoupon() {
      return this.isOpenBooking && this.booking.openBookingSendCoupon
    },
    isOpenBookingSendGift() {
      return this.isOpenBooking && this.booking.openBookingSendGift
    },
    // 【已注释 2026-09-14】全仓无任何引用；其依赖的 bookingStatusHelper.getStatusName 已同步注释
    // statusName() {
    //   return bookingStatusHelper.getStatusName(this.booking)
    // },
    status() {
      return bookingStatusHelper.getBookingStatus(this.booking)
    },
    balanceDue() {
      return this.booking.balanceDue
    },
    bookingCreateDate() {
      let createdDate = ""
      if (this.booking.orderCreateDate != null && this.booking.orderCreateDate != "") {
        createdDate = this.booking.orderCreateDate + ""
      } else if (this.booking.bookingCreateDate != null && this.booking.bookingCreateDate != "") {
        createdDate = this.booking.bookingCreateDate + ""
      }

      if (createdDate && createdDate.length > 0) {
        let payDate = new Date(createdDate)
        let payMonth = payDate.getMonth() + 1 < 10 ? "0" + (payDate.getMonth() + 1) : payDate.getMonth() + 1
        let payDay = payDate.getDate() < 10 ? "0" + payDate.getDate() : payDate.getDate()
        return payDate.getFullYear() + "/" + payMonth + "/" + payDay
      }

      return ""
    },
    guestNames() {
      if (!this.booking.guestName || this.booking.guestName.length == 0) return []
      return this.booking.guestName.split("，")
    },
    isBookingUnPaid() {
      return this.status == 'unpaid' || this.status == 'unpaidFull'
    },
    isOpenBookingSelected() {
      return this.selectedOpenBooking.some(r => r.openBookingOrderId == this.booking.openBookingOrderId)
    },
    isBookingSelected() {
      return this.selectedBooking.some(r => r.bookingRecordId == this.booking.bookingRecordId)
    },
    canPay() {
      return (this.status == "unpaid" && !this.isExpired)
        || (this.status == "unpaidFull" && (this.balanceDue + this.booking.payAmount == this.booking.total))
    },
    isExpired() {
      var expired = false;
      const sailDate = new Date(this.booking.sailDate)
      const curDate = new Date()
      if (sailDate <= curDate && !this.isOpenBooking) {
        expired = true;
      } else if (this.isOpenBooking && this.booking.openBookingEndDate && this.booking.openBookingEndDate.length > 0) {
        const openBookingEndDate = new Date(this.booking.openBookingEndDate.trim().substr(0, 10))
        if (openBookingEndDate < curDate) {
          expired = true
        }
      }
      return expired
    },
    cruiseDetailLink() {
      if (!this.booking || !this.booking.sailDate) {
        return ''
      }
      return '/Rccl.Cruise/CruiseDetail?shipCode=' + this.booking.shipCode + '&sailDate=' + this.booking.sailDate.split('T')[0]
    },
    payLink() {
      if (!this.isOpenBooking) {
        // 使用加密字段encBookingId
        return `/Rccl.Booking/Booking/Pay?bookingId=${this.booking.encBookingId}`
      } else {
        return `/Rccl.Booking/OpenBooking/Detail?orderId=${this.booking.openBookingOrderId}`
      }
    },
    cruiseSearchLink() {
      var sailDays = parseInt(this.booking.sailDays);
      if (sailDays <= 3) {
        sailDays = 3;
      } else if (sailDays >= 4 && sailDays <= 5) {
        sailDays = 4;
      } else if (sailDays >= 6) {
        sailDays = 6;
      }
      const search = '/Rccl.Cruise/CruiseSearch/Search?departureCodes=' + this.booking.cruiseDeparture + '&sailDays=' + sailDays;
      return search
    },
    orderDetailLink() {
      if (!this.isOpenBooking) {
        // 使用加密字段encBookingId
        return `/Rccl.Booking/Booking/BookingDetail?bookingId=${this.booking.encBookingId}`
      } else {
        return `/Rccl.Booking/OpenBooking/Detail?orderId=${this.booking.openBookingOrderId}`
      }
    },
    giftLink() {
      const giftLink = `${process.env.VUE_APP_REWARD_URL}/rewardpc/member/shop/gift`
      if (this.userInfo && this.userInfo.userIdentity == 1) {
        return `${giftLink}?token=${this.userInfo.localRewardToken}`
      } else {
        return `/Rccl.UserCenter/CustomerInfo/SignupReward?returnUrl=${encodeURIComponent(giftLink)}`
      }
    },
    upgradeCabinItem(){
      console.log(this.booking)
      return this.booking.upgradeCabinItem
    },
    // 待付款样式-red，其余-无
    // bookingStatusHelper.isUnpaidPaymentStatus 中维护
    paymentStatusTagClass() {
      return bookingStatusHelper.isUnpaidPaymentStatus(this.booking.bookingBusinessStatus.paymentStatusCode)
          ? 'red'
          : ''
    }
  }
}
</script>

<style lang="less" scoped>
.ord_item_con {
  margin-top: 10px;

  .item_head_con {
    position: relative;
    overflow: hidden;
    width: calc(100% - 1px);
    height: 32px;
    line-height: 32px;
    margin-left: 1px;
    background-color: #f5f5f5;
    padding: 0 20px;
    color: #747d80;

    >span {
      display: inline-block;
      margin-right: 5px;
    }

    >span.head_text {
      color: #282b2c;
    }

    span.item_head_split {
      margin: 0px 8px;
    }

    & .gratuitiesLink {
      float: right;
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1;
      margin-top: 7px;
      gap: 4px;
      color: #006AB6;
      & a {
        line-height: 1;
      }
      & img {
        display: block;
      }
      & .icon{
        height: 18px;
        width: 18px;
      }
      & .arrow{
        height: 10px;
        width: 6px;
      }
    }
  }

  .item_con {
    overflow: hidden;
    min-height: 110px;
    padding: 10px 0;
    border-bottom: 1px solid #d3dadd;
    vertical-align: middle;

    &.isCancelled {
      color: #b9b9b9 !important;
      & .center_con div {
        color: #b9b9b9 !important;
      }
    }

    .item_com {
      float: left;
      min-height: 102px;
      padding-left: 20px;
      position: relative;

      .center_con {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);

        &.tac {
          left: 20px;
          right: 0;
          text-align: center;
        }

        .ship_departure {
          color: #747d80;
        }

        .user_con {
          float: left;
          width: 100%;

          >div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .money_title {
          font-size: 16px;
          color: #ff3022;
        }

        div {
          line-height: normal;
        }
      }

      .op_con {
        left: 20px;
        right: 0;
        text-align: right;

        .op_text_inner {
          display: inline-block;
          //width: 90px;

          &.is-tip {
            margin-right: 20px;
          }

          .op_text {
            text-align: center;
            padding-top: 3px;
            margin: 0 auto;
            .invoice-btn{
              color: #337ab7;
              cursor: pointer;
              &:hover{
                color: #23527c;
                text-decoration: underline;
              }
            }
          }

          .personal_order .blue {
            color: #006ab9;
          }

          .payBtn {
            position: relative;

            .op_btn {
              display: inline-block;
              width: 90px;
              height: 32px;
              line-height: 32px;
              background-color: #fbc500;
              color: #282b2c;
              text-align: center;
              cursor: pointer;
            }

            .hold_link {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index: 10;
            }
          }
        }

        .op_tip_img {
          position: absolute;
          top: 5px;
          right: 0;
        }
      }

      .line_title {
        color: #282b2c;
        margin-bottom: 5px;
      }
    }

    .questionnaire {
      height: 20px;
      box-sizing: border-box;
      text-align: right;
      padding-right: 40px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: right;
      gap: 5px;
      a{
        color: #006ab5;
        cursor: pointer;
      }
      span {
        height: 20px;
        cursor: pointer;
        text-decoration: none;
      }

      .scoreIcon {
        display: inline-block;
        //background-color: #0A77BA;
        width: 15px;
        height: 16px;
        line-height: 14px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .fill-guest-btn {
      display: block;
      padding: 0 10px;
      height: 32px;
      line-height: 32px;
      margin: 5px auto 0;
      width: 90px;
      color: #127bc6;
      border: 1px dashed #127bc6;
      background-color: #EEF5FB;
      text-decoration: none;

      &:hover {
        background-color: #e1f1ff;
      }

      &:active {
        background-color: #EEF5FB;
      }
    }
  }

  .line_w {
    width: 279px;
  }

  .passengers_w {
    width: 180px;
    position: relative;
    z-index: 1;
  }

  .ship_w {
    margin-left: 20px;
    width: 188px;
  }

  .money_w {
    width: 128px;
  }

  .operation_w {
    width: 140px;
    text-align: right;
  }

  .c_userCenterImg,
  .qiaohu_tag {
    cursor: pointer;
  }
  .starry_sky_tag {
    cursor: pointer;
  }
  .pcp_gift_tag {
    cursor: pointer;
    height: 24px;
    margin-top: 1px;
  }
  .custom_theme_tag {
    cursor: pointer;
    height: 22px;
  }
  .c_userCenterImg {
    margin-right: 5px;
  }
}

.red {
  color: #ff3022;
  font-size: 13px;
}

.cabinItem-un-filled-red {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  margin: 0 20px 10px;
  font-size: 14px;
  color: #ff2742;
  padding: 5px 10px;
  background-color: #fff1f1;

  & .icon {
    height: 20px;
  }

  & .text {
    line-height: 20px;
  }
}
.bidding-status{
  color: #1c77ba;
  cursor: pointer;
  text-align: center;
  :hover{
    color: #4d52a2;
    text-decoration: underline;
  }
}
</style>
<style lang="css">
.el-popper[x-placement^=left] .popper__arrow {
  right: -10px;
}

.el-popper[x-placement^=left] .popper__arrow::after {
  bottom: -12px;
}

.el-popper .popper__arrow::after {
  border-width: 12px;
}

.el-popper[x-placement^=right] .popper__arrow {
  left: -10px;
}

.el-popper[x-placement^=right] .popper__arrow::after {
  bottom: -12px;
}

.el-popper .popper__arrow::after {
  border-width: 12px;
}
</style>
<style lang="less">
.user_con {
  .tooltip-inner {
    min-width: 390px;
    text-align: left;
    padding: 8px 10px;
    opacity: 1;
    z-index: 9;
  }

  .tooltip.bs-tooltip-top .arrow {
    display: none;
  }

  .tooltip.bs-tooltip-top::after {
    position: absolute;
    bottom: -18px;
    left: 50%;
    margin-left: -6px;
    content: " ";
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: #ffffff;
  }

  .tooltip {
    top: -8px !important;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1) !important;
    //left: -134px !important;
  }
}</style>
